export enum TeamTypes {
  Business = 'business',
  Marketing = 'marketing',
  ProjectManagement = 'project management',
  Education = 'education',
  EngineeringIT = 'engineering-it',
  Sales = 'sales',
  Other = 'other',
}
